import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice'
import categoryReducer from '../features/category/categorySlice'
import productReducer from '../features/product/productSlice'
import cartReducer from '../features/cart/cartSlice'
import orderReducer from '../features/order/orderSlice'
import tenantReducer from '../features/tenant/tenantSlice'
import fiscalReducer from '../features/fiscal/fiscalSlice'
import invoiceReducer from '../features/invoice/invoiceSlice'
import supplierReducer from '../features/supplier/supplierSlice';
import purchaseReducer from '../features/purchase/purchaseSlice';
import uiReducer from '../features/ui/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    category: categoryReducer,
    product: productReducer,
    cart: cartReducer,
    order: orderReducer,
    tenant: tenantReducer,
    fiscal: fiscalReducer,
    invoice: invoiceReducer,
    supplier: supplierReducer,
    purchase: purchaseReducer,
    ui: uiReducer,
  },
});
